import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { IRegistrationLoginRequest, IRegistrationLoginSuccess } from '../models/registration-login.model';
import { loadLoginRequest, loadLoginSuccess, loadLoginFailure, clearLoginFailure, clearLoginSuccess } from '../actions/login.actions';
import { IBusinessLoginRequest, IBusinessLoginResponse } from '../models/business-login.model';
export const loginFeatureKey = 'login';
export interface LoginState {
  isLoading: boolean;
  loadLoginRequest: IBusinessLoginRequest;
  loadLoginSuccess: IBusinessLoginResponse;
  loadLoginFailure: IGenericError<ErrorResponse>;
}
export const initialState: LoginState = {
  isLoading: false,
  loadLoginFailure: undefined,
  loadLoginRequest: undefined,
  loadLoginSuccess: undefined
};
export const reducer = createReducer(
  initialState,
  //#region LOGIN
  on(loadLoginRequest, (state, action) => ({
    ...state,
    loadLoginRequest: action.request,
    isLoading: true
  })),
  on(loadLoginSuccess, (state, action) => ({
    ...state,
    loadLoginSuccess: action.response,
    isLoading: false
  })),
  on(loadLoginFailure, (state, action) => ({
    ...state,
    loadLoginFailure: action.error,
    isLoading: false
  })),
  on(clearLoginFailure, (state, action) => ({
    ...state,
    loadLoginFailure: undefined
  })),
  on(clearLoginSuccess, (state, action) => ({
    ...state,
    loadLoginSuccess: undefined
  }))
  //#endregion
);
//#region LOGIN
export const getIsLoginLoading = (state: LoginState) => state.isLoading;
export const getLoginRequest = (state: LoginState) => state.loadLoginRequest;
export const getLoginSuccess = (state: LoginState) => state.loadLoginSuccess;
export const getLoginFailure = (state: LoginState) => state.loadLoginFailure;
//#endregion
